import { render, staticRenderFns } from "./PaymentContract.vue?vue&type=template&id=a2816a10&scoped=true&"
import script from "./PaymentContract.vue?vue&type=script&lang=js&"
export * from "./PaymentContract.vue?vue&type=script&lang=js&"
import style0 from "./PaymentContract.vue?vue&type=style&index=0&id=a2816a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2816a10",
  null
  
)

export default component.exports